import './App.css';

function App() {
  return (
    <div className="App">
      <div className="App-header">
        <div className="hearts">
          <span className="heart heart-1">❤️</span>
          <span className="heart heart-2">💖</span>
          <span className="heart heart-3">💕</span>
          <span className="heart heart-4">❤️</span>
          <span className="heart heart-5">💖</span>
          <span className="heart heart-6">💕</span>
        </div>
        <h1 className="gros-naze">GROS NAZE</h1>
      </div>
    </div>
  );
}

export default App;
